module.exports = __webpack_public_path__ + "static/media/icon-ville.1a350dd5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-ville.svg
// module id = 617
// module chunks = 0